export default "__VITE_ASSET__8731cc44__"